// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hover":"_26_jTM","underline":"_3d7TN0","horizontal-padding--mobile":"_2XDRZy"};